import React, { CSSProperties } from "react";

type propsType = Pick<CSSProperties, "maxHeight" | "maxWidth"> & {
    children?: React.ReactNode;
    style?: CSSProperties;
};

export const ConstrainedBox: React.FC<propsType> = (props: propsType) => {
    const style: CSSProperties = {
        ...props,
        ...props.style,
    };
    return (
        <div data-testid="ConstrainedBox" style={style}>
            {props.children}
        </div>
    );
};
